import React, { FunctionComponent } from 'react';
import styles from './DonationReminder.scss';
import { useApp } from '../../hooks/useApp';
import { MODAL } from '../../context';
import { useTranslation } from 'react-i18next';
import useBasePageQuery from '../../hooks/useBasePageQuery';
import { useFlags } from '../../hooks';

// OTG 2023 - Tom Hedges

export const DonationReminder: FunctionComponent = () => {
  const { t } = useTranslation('common', { useSuspense: false });
  const { showModal } = useApp();
  const { data: basePageData } = useBasePageQuery();

  const { showFrpSetReminderButton } = useFlags();
  if (!showFrpSetReminderButton) return null;

  if (!basePageData?.page?.relationships?.events?.nodes[0]?.startDate) {
    return null;
  }

  return (
    <button
      onClick={() => showModal({ modal: MODAL.DONATION_REMINDER })}
      className={`jg-text--link ${styles.reminderButton}`}
      data-qa="donation-reminder-button"
    >
      {t('donationReminder.setReminder')}
    </button>
  );
};
